export const headerData=['货主名称','客户编号','客户名称','助记码','地址',
  '地区','等级','识别','批号数','上级客户','所在地','标签分割量','简称',
  '客户分类', '库存周转方式', '联系人','电话','数据源','是否内部客户','是否后台客户',
  '是否已审核', '是否可用','是否下游客户','是否上游客户']
export const filterVal=['storer','no','name','mnemonicCode','address',
  'district', 'grade','identifier','numberOfLot','parent','seat','separationOfLabel','shortName',
  'classification', 'turnoverMode', 'businessman','phone','dataSource','inner','background',
  'approved','available','downstream','upstream']
export const excelName='客户资料'